import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { FileProgress } from './FileProgress';
import { FileStateIcon } from './FileStateIcon';
import { FileStateContainer } from './styled';
export const FileState = memo(function FileState({ error, isUploading, onReset, progress, success, tryAnotherText, }) {
    if (!isUploading && !success && !error) {
        return null;
    }
    const progressVisible = !!(progress && progress !== -1);
    return (_jsxs(FileStateContainer, { children: [progressVisible && !error && _jsx(FileProgress, { progress: progress }), _jsx(FileStateIcon, { error: error, isUploading: isUploading, onReset: onReset, progressVisible: progressVisible, success: success, tryAnotherText: tryAnotherText })] }));
});
